import { render } from "./myUploads.vue?vue&type=template&id=1c81b650&scoped=true"
import script from "./myUploads.vue?vue&type=script&lang=js"
export * from "./myUploads.vue?vue&type=script&lang=js"

import "./myUploads.vue?vue&type=style&index=0&id=1c81b650&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c81b650"]])

export default __exports__